import { FC } from 'react';

import { PLAN_CARD_TEST_ID } from '../constants';
import { useDetailsModalControls } from '../hooks/useDetailsModalControls';
import { PlanCardModel } from '../model';
import { DetailsUList } from '../PlanCard.styles';
import { DetailsModalTriggerButton } from './DetailsModalTriggerButton';

export const DetailsList: FC<{ details: PlanCardModel.Detail[]; isNegative: boolean }> = ({ details, isNegative }) => {
    const { openDetailsModal } = useDetailsModalControls();

    if (!details?.length) {
        return null;
    }

    return (
        <DetailsUList data-test={PLAN_CARD_TEST_ID.DETAILS_LIST}>
            {details.map((d, index) => (
                <li key={index}>
                    <DetailsModalTriggerButton
                        isDisabled={!d.available}
                        isNegative={isNegative}
                        onClick={(event) => openDetailsModal({ id: d.id, modalTitle: d.text }, event.currentTarget)}
                    >
                        {d.text}
                    </DetailsModalTriggerButton>
                </li>
            ))}
        </DetailsUList>
    );
};
